import { createActionGroup, emptyProps, props } from '@ngrx/store';
import type { SessionEndType } from '../session.service';

export interface LoginSuccessPayload {
  token: string;
  expiresAt: number;
  userId: string;
  displayName: string;
  email: string;
}

export const AuthActions = createActionGroup({
  source: 'Auth',
  events: {
    'Login Initiated': emptyProps(),
    'Login Success': props<LoginSuccessPayload>(),
    'Login Failure': props<{ error: string }>(),
    // endType is sent to POST /sessions/end: VOLUNTARY for a user sign-out (the
    // default), TIMEOUT when the app forces sign-out (refresh failure).
    Logout: (props: { endType: SessionEndType } = { endType: 'VOLUNTARY' }) => props,
    // The API rejected the token (401): Curity has already ended the session, so
    // everything is cleared locally and the user signs in again — no API or IdP calls.
    'Session Expired': emptyProps(),
    'Token Refreshed': props<{ token: string; expiresAt: number }>(),
  },
});
